import Admin from './components/Dashboard';
import NotFound from './components/modules/dashboard/404';
import BlankPage from './components/modules/common-page/BlankPage';
import Login from './components/modules/auth/Login';
import Logout from './components/modules/auth/Logout';
import NotFoundSecond from './components/modules/dashboard/500';
import ResetPassword from './components/modules/auth/ResetPassword';
import ChangePassword from './components/modules/auth/ChangePassword';

// publisher
import AllPublisher from './components/modules/admin/AllPublisher';

//bidders
import Bidders from './components/modules/admin/Bidders';
import BidderDomain from './components/modules/bidder/Domain';
import BidderBulkDomain from './components/modules/bidder/BulkDomain';
import BulkLineItem from './components/modules/bidder/BulkLineItem';
import BidderPublisher from './components/modules/bidder/Publisher';
import LineItemsOfBidders from './components/modules/admin/Adspotofbidders';
import ReportsRevenue from './components/modules/admin/reports';

// Admin
import AddPublisher from './components/modules/admin/AddPublisher';
import PaymentForm from './components/modules/admin/PaymentForm';
import PreviewPDF from './components/modules/admin/PreviewPDF';
import Publisher from './components/modules/admin/Publisher';
import EditPublisher from './components/modules/admin/EditPublisher';
import PublisherInfo from './components/modules/admin/PublisherInfo';
import DomainContext from './components/modules/admin/DomainContext';
import AdsText from './components/modules/admin/AdsText';
import KeywordBlock from './components/modules/admin/KeywordBlock';
import Profile from './components/modules/pages/Profile';
import Demo from './components/modules/pages/Demo';
import AxtModule from './components/modules/axt/AxtModule';
import StickyModule from './components/modules/axt/ConfigStickyTemplate';
import HBModule from './components/modules/header-bidding/ConfigHbTemplate';
import Domain from './components/modules/admin/AllDomain';
import CreateDomain from './components/modules/admin/CreateDomain';
import DomainBucket from './components/modules/admin/DomainBucket';
import EditDomain from './components/modules/admin/EditDomain';
import BucketDetails from './components/modules/admin/BucketDetails';
import Notes from './components/modules/admin/Notes';
import HBBucketTags from './components/modules/dfp/HBBucketTags';

// DPF pages:
import DfpSettings from './components/modules/dfp/DfpSettings';
import EditDfp from './components/modules/dfp/EditDfp';
import CreateHbTag from './components/modules/dfp/CreateHbTag';
import ModifyHbTag from './components/modules/dfp/ModifyHbTag';
// import HbTagParams from './components/modules/dfp/HbTagParams'
import HbTagParams from './components/modules/dfp/HbTagParamsNew';
import HbTagDimensionParams from './components/modules/dfp/HbTagDimensionParams';
import HbTagParamSet from './components/modules/dfp/HbTagParamSet';
// import HbTagParamsAMP from './components/modules/dfp/HbTagParamsAMP'
import BlockCategories from './components/modules/admin/BlockCategories';
import BlockUrls from './components/modules/admin/BlockUrls';

//Direct Campaign
import CreateDirectCampaign from './components/modules/direct-campaign/CreateDirectCampaign';
import AllDirectCampaign from './components/modules/direct-campaign/AllDirectCampaign';

import FirstImpression from './components/modules/first-impression/FirstImpression';
import FiSetupAdSpots from './components/modules/first-impression/FiSetupAdSpots';
import DiagRedirect from './components/modules/first-impression/DiagRedirect';
import Layout from './components/modules/first-impression/Layout';
import FiTagAssociation from './components/modules/first-impression/FiTagAssociation';

// Reports
import ReportsAdmin from './components/modules/reports/ReportsAdmin';
import ReportsAdminApproval from './components/modules/reports/ReportsAdminApproval';
import ReportsConfig from './components/modules/reports/ReportsConfig';
import BidderRevenueReports from './components/modules/reports/BidderRevenueReports';
import BidderDfpReport from './components/modules/reports/BidderDfpReport';

// Routes

const routes = [
    {
        path: '*',
        redirect: '/admin/domains',
    },
    {
        path: '/',
        redirect: '/login',
        meta: {
            auth: {
                auth: false,
            },
        },
    },

    {
        path: '/admin/domains/',
        name: 'Admin',
        component: Admin,
        meta: {
            auth: true,
        },

        beforeEnter: (_to, _from, next) => {
            document.body.className += 'skin-gradient sidebar-mini';
            next();
        },
        activate: function () {
            this.$nextTick(function () {
                // => 'DOM loaded and ready'
            });
        },
        children: [
            {
                path: '/admin/publisher/add',
                name: 'AddPublisher',
                component: AddPublisher,
                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/publishers/',
                name: 'AllPublisher',
                component: AllPublisher,

                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/publisher/:pubid/ReportsRevenue/:domid',
                name: 'ReportsRevenue',
                component: ReportsRevenue,

                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/bidders/',
                name: 'Bidders',
                component: Bidders,
                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/bidders/create-publisher',
                name: 'BidderPublisher',
                component: BidderPublisher,
                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/bidders/create-bulk-line-item',
                name: 'BulkLineItem',
                component: BulkLineItem,
                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/bidders/create-domain',
                name: 'BidderDomain',
                component: BidderDomain,
                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/bidders/create-bulk-domain',
                name: 'BidderBulkDomain',
                component: BidderBulkDomain,
                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/bidders/domain/:domId',
                name: 'BidderDomain',
                component: BidderDomain,
                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/lineitems/:id',
                name: 'lineitems',
                component: LineItemsOfBidders,

                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },

            {
                path: '/admin/publisher/contract/:id',
                name: 'PaymentForm',
                component: PaymentForm,
                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/publisher/previewpdf',
                name: 'PreviewPDF',
                component: PreviewPDF,
                meta: {
                    auth: {
                        auth: true,
                        // roles: 'publisher',
                    },
                },
            },
            {
                path: '/admin/password/change',
                name: 'ChangePassword',
                component: ChangePassword,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher',
                name: 'Publisher',
                component: Publisher,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/domains',
                name: 'Domain',
                component: Domain,
                meta: {
                    auth: true,
                },
                children: [{ path: 'notes/:domid', component: Notes }],
            },
            {
                path: '/admin/create-domain',
                name: 'CreateDomain',
                component: CreateDomain,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/edit/:uuid',
                name: 'EditPublisher',
                component: EditPublisher,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/buckets/',
                name: 'DomainBucket',
                component: DomainBucket,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/',
                name: 'BucketDetails',
                component: BucketDetails,
                meta: {
                    auth: true,
                },
                redirect: (to) => {
                    return { path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/hb-tags' };
                },
            },

            {
                path: '/admin/publisher/:uuid/domain/edit/:domId',
                name: 'DomainContext',
                component: DomainContext,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/adstxt/:domId',
                name: 'ads.txt',
                component: AdsText,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/KeywordBlock/:domId',
                name: 'KeywordBlock',
                component: KeywordBlock,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher-info/:uuid/:id',
                name: 'PublisherInfo',
                component: PublisherInfo,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/dc/add',
                name: 'CreateDirectCampaign',
                component: CreateDirectCampaign,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/dc/',
                name: 'AllDirectCampaign',
                component: AllDirectCampaign,
                meta: {
                    auth: true,
                },
            },

            {
                path: '/admin/publisher/:uuid/domain/:domId/ad-spot-setup/',
                name: 'FiSetupAdSpots',
                component: FiSetupAdSpots,
                meta: {
                    auth: true,
                },
                props: true,
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/layout-setup/',
                name: 'Layout',
                component: Layout,
                meta: {
                    auth: true,
                },
                props: true,
            },

            {
                path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/fi/',
                name: 'FiTagAssociation',
                component: FiTagAssociation,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/settings',
                name: 'BucketSettings',
                component: BucketDetails,
                meta: {
                    auth: true,
                },
            },

            {
                path: '/profile',
                name: 'Profile',
                component: Profile,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/axt',
                name: 'AxtModule',
                component: AxtModule,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/hb-tags',
                name: 'Header-Bidding-Tags',
                component: HBBucketTags,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/sticky',
                name: 'StickyModule',
                component: StickyModule,
                meta: {
                    auth: true,
                },
            },

            {
                path: '/admin/dfp-settings',
                name: 'DfpSettings',
                component: DfpSettings,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/edit-dfp/:dfpId',
                name: 'Edit DPF',
                component: EditDfp,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/reports',
                name: 'Reports',
                component: ReportsAdmin,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/report-approval/:reportName/',
                name: 'reportApproval',
                component: ReportsAdminApproval,
                meta: {
                    auth: true,
                },
                props: true,
            },
            {
                path: '/admin/reports/config',
                name: 'ReportsConfig',
                component: ReportsConfig,
                meta: {
                    auth: true,
                },
                props: true,
            },
            {
                path: '/admin/updated-report/:reportName/',
                name: 'BidderDfpReport',
                component: BidderDfpReport,
                meta: {
                    auth: true,
                },
                props: true,
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/create-hb-tag/',
                name: 'CreateHbTag',
                component: CreateHbTag,
                meta: {
                    auth: true,
                },
                props: {
                    is_amp: false,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/create-hb-tag-amp/',
                name: 'CreateHbTagAmp',
                component: CreateHbTag,
                meta: {
                    auth: true,
                },
                props: {
                    is_amp: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/modify-hb-tag/:id/',
                name: 'ModifyHbTag',
                component: ModifyHbTag,
                meta: {
                    auth: true,
                },
                props: {
                    is_amp: false,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/modify-hb-tag-amp/:id/',
                name: 'ModifyHbTagAmp',
                component: ModifyHbTag,
                meta: {
                    auth: true,
                },
                props: {
                    is_amp: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/hb-tags/',
                name: 'HbTagParams',
                component: HbTagParams,
                meta: {
                    auth: true,
                },
                props: {
                    is_amp: false,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/hb-tags-dimensions/',
                name: 'HbTagDimensionParams',
                component: HbTagDimensionParams,
                meta: {
                    auth: true,
                },
                props: {
                    is_amp: false,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/hb-tag-param-sets/',
                name: 'HbTagParamSet',
                component: HbTagParamSet,
                meta: {
                    auth: true,
                },
                props: {
                    is_amp: false,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/hb-tags-amp/',
                name: 'HbTagParamsAMP',
                component: HbTagParams,
                meta: {
                    auth: true,
                },
                props: {
                    is_amp: true,
                },
            },

            {
                path: '/admin/publisher/:uuid/domain/:domId/settings/block-categories',
                name: 'BlockCategories',
                component: BlockCategories,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/settings/edit',
                name: 'EditDomain',
                component: EditDomain,
                meta: {
                    auth: true,
                },
            },
            {
                path: '/admin/publisher/:uuid/domain/:domId/settings/block-urls',
                name: 'BlockURLS',
                component: BlockUrls,
                meta: {
                    auth: true,
                },
            },
        ],
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            auth: false,
        },
    },
    {
        path: '/diag-spot/:adSpotId',
        name: 'DiagRedirect',
        component: DiagRedirect,
        meta: {
            auth: true,
        },
    },
    {
        path: '/reset/:id/:resetID',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
            auth: false,
        },
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout,
        meta: {
            auth: true,
        },
    },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js